import { useState } from "react";

import UserSettingsService from "@services/userSettingsService";

export const useFilePageTree = () => {
    const [isOpen, setIsOpen] = useState(UserSettingsService.getFilePageTreeOpen());

    const onToggle = () => {
        setIsOpen((prev) => {
            UserSettingsService.setFilePageTreeOpen(!prev);
            return !prev;
        });
    };

    return { isOpen, onToggle };
};
